import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { resetPassword, forgetPassword } from './cognitoUtils';

const Forgetpassword = () => {
  const navigate = useNavigate(); 
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const username = queryParams.get('username')
  const [code, setCode] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [message, setMessage] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
  
    if (password1 !== password2) {
      setMessage('Passwords do not match.');
      return;
    }
  
    try {
      await resetPassword(username, code, password1);
      setMessage('Reset password successful!');
      navigate('/auth'); 

    } catch (error) {
      setMessage(error.message || 'An unknown error occurred.');
    }
  };
    

  if (!username) {
    // console.log(username)
    navigate('/auth');
    return null;
  }

  return (
    <div className="wrapper">
      <div className="title-text">
        <div className={'title'}>
          Reset Password
        </div>
      </div>
      <div className="form-container">
        <div className="form-inner">
          <form onSubmit={handleReset} className="login">
            <div className="field">
              <input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Code"
                required
              />
            </div>
            <div className="field">
              <input
                type="password"
                value={password1}
                onChange={(e) => setPassword1(e.target.value)}
                placeholder="Password"
                required
              />
            </div>
            <div className="field">
              <input
                type="password"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                placeholder="Enter Password Again"
                required
              />
            </div>
            <div className="error-message">
              <p>{message}</p>
            </div>
            <div className="field btn">
              <div className="btn-layer"></div>
              <input type="submit" value="Confirm" />
            </div>
            <div className="signup-link">
              <a href="#" onClick={()=>forgetPassword(username)}>
                Re-send Code
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Forgetpassword;
